const pillars = [
  {
    icon: 'ri-award-line',
    title: 'Certified Excellence',
    desc: 'Factory-trained technicians holding elite manufacturer certifications, delivering OEM-level results on every repair.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Insurance Dispute Specialist',
    desc: 'We work directly with all major insurance carriers, handling the entire claims process so you don\'t have to.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Perfection Driven',
    desc: 'Every vehicle leaves our facility meeting or exceeding factory specifications. We accept nothing less than flawless.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Trusted by Luxury Owners',
    desc: 'The preferred collision center for owners of Mercedes-Benz, BMW, Porsche, and other premier automotive brands.',
  },
];

export default function Trust() {
  return (
    <section className="relative w-full py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1f607ca8e4241b9410ebd965f3071b5e.jpg"
          alt="Premium auto body shop"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/85"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#080808] via-transparent to-[#080808]"></div>
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-16">
        <div className="text-center mb-16">
          <span className="text-yellow-600 text-xs tracking-[0.4em] uppercase font-light">Why Choose Us</span>
          <h2 className="font-serif text-4xl md:text-5xl text-white mt-4">
            The Royal <span className="text-yellow-400 italic">Standard</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((p) => (
            <div key={p.title} className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full border border-yellow-600/40 bg-yellow-900/10 group-hover:bg-yellow-900/30 group-hover:border-yellow-500/60 transition-all duration-400">
                <i className={`${p.icon} text-3xl text-yellow-500`}></i>
              </div>
              <h3 className="text-white font-serif text-xl mb-3">{p.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed font-light">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
